import type { UserRole } from '@doneverse/shared'

/**
 * Boundary-aware route match: '/teams' matches '/teams' and '/teams/1', not
 * '/teams-x'.
 *
 * Lives here rather than beside any one consumer because "is this pathname on
 * or under this route" is the shared rule behind every access decision in the
 * app — the nav's active state, the restricted-doer allowlist, the flag route
 * guard and the onboarding lock all ask it, and they must all answer it the
 * same way.
 */
export function matchesPathPrefix(pathname: string, prefix: string): boolean {
  return pathname === prefix || pathname.startsWith(`${prefix}/`)
}

/**
 * Centralized home page routing by role.
 * Update this single location to change where users land after login.
 */
export function getHomeRoute(role: UserRole | undefined): string {
  switch (role) {
    case 'admin':
      return '/admin/stats'
    case 'founder':
      return '/start-here'
    case 'doer':
      return '/doer-home'
    case 'doing_team':
      return '/projects'
    case 'intake_team':
      return '/intake'
    case 'escalation_officer':
      return '/escalations'
    case 'dsl':
      return '/admin/activity-log'
    default:
      return '/doing-blueprint'
  }
}
